<template>
  <div class="index">
    <component
      :is="component"
      @showUpload="showUpload"
      :detailParams="detailParams"
      @uploadSuccess="uploadSuccess"
    ></component>
    <right-box @showDetail="showDetail" ref="rightBox"></right-box>
  </div>
</template>

<script>
import PhoneUpload from './components/phoneUpload'
import PhoneFeedbackDetail from './components/phoneFeedbackDetail'
import RightBox from './components/rightBox'
export default {
  components: {
    RightBox
  },
  data () {
    return {
      component: PhoneUpload, // 动态组件
      detailParams: {} // 传给详情页的数据
    }
  },
  methods: {
    /**
     * 显示详情页
     * @param detailParams: 一次提交事件的各项数据
     */
    showDetail (detailParams) {
      this.detailParams = detailParams
      this.component = PhoneFeedbackDetail
    },

    /**
     * 显示上传页面
     */
    showUpload () {
      this.component = PhoneUpload
    },

    /**
     * 上传成功
     */
    uploadSuccess () {
      this.$refs.rightBox.initData()
    }
  }
}
</script>

<style scoped>
.index {
  display: flex;
  padding: 24px 32px;
}
</style>
